import { SCORE_LABELS, scoreTone } from "@/components/Scores";

const TONE = { emerald: "text-emerald-300", amber: "text-amber-300", rose: "text-rose-300" };

const ROWS = [
  ["Complessivo", (i) => i.punteggio_complessivo, true],
  ...Object.entries(SCORE_LABELS).map(([k, l]) => [l, (i) => i.punteggi?.[k], true]),
  ["Costi di avvio", (i) => i.costi_avvio],
  ["Primo guadagno", (i) => i.tempo_primo_guadagno],
  ["Potenziale", (i) => i.guadagno_potenziale],
  ["Modelli", (i) => (i.modelli_guadagno || []).map((m) => m.tipo).join(", ")],
];

const CompareRow = ({ label, get, isScore, ideas }) => {
  const vals = ideas.map((i) => Number(get(i)) || 0);
  const best = Math.max(...vals);
  return (
    <tr className="border-t border-white/5">
      <td className="p-3 text-slate-400">{label}</td>
      {ideas.map((i, idx) => (
        <td key={i.id} className={`p-3 ${isScore ? `font-mono ${TONE[scoreTone(vals[idx])]} ${vals[idx] === best ? "font-bold" : ""}` : "text-slate-300"}`}>
          {get(i) ?? "—"}{isScore && vals[idx] === best && ideas.length > 1 ? " ★" : ""}
        </td>
      ))}
    </tr>
  );
};

export const CompareTable = ({ ideas }) => (
  <div className="overflow-x-auto">
    <table className="w-full text-sm" data-testid="compare-table">
      <thead>
        <tr>
          <th className="text-left p-3 text-slate-500 font-medium w-40" />
          {ideas.map((i) => <th key={i.id} className="text-left p-3 font-display font-semibold text-slate-100 align-bottom">{i.nome}</th>)}
        </tr>
      </thead>
      <tbody>
        {ROWS.map(([label, get, isScore]) => <CompareRow key={label} label={label} get={get} isScore={isScore} ideas={ideas} />)}
      </tbody>
    </table>
  </div>
);
